import {useState} from "react";
import {cloneDeep, isEmpty} from "lodash";
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import {OBJECT_TYPES} from "../../../constants/objectTypes";
import {useHandleCustomFieldsForObject} from "../../../hooks/useHandleCustomFieldsForObject";
import {createUpdateWebHook} from "../../../redux/Actions/webhooks.actions";
import {DEFAULT_FORM_DATA} from "./constants";

export const useFormData = (data = cloneDeep(DEFAULT_FORM_DATA), callback) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState(data);

  const setCustomFields = (customFields) => {
    setFormData((prevData) => ({
      ...prevData,
      custom_fields: customFields,
    }));
  };

  const {generateCustomFieldsPayload} = useHandleCustomFieldsForObject(
    OBJECT_TYPES.Webhook,
    data.id,
    setCustomFields
  );

  const {custom_fields = [], http_method, name, url} = formData;

  const handleChange = (e) => {
    setFormData((prevData) => ({...prevData, [e.target.name]: e.target.value}));
  };

  const handleHeaderChange = (index, field, value) => {
    setFormData((prevData) => {
      const updatedHeaders = [...prevData.additional_headers];
      updatedHeaders[index][field] = value;
      return {...prevData, additional_headers: updatedHeaders};
    });
  };

  const addHeaderField = () => {
    setFormData((prevData) => ({
      ...prevData,
      additional_headers: [...prevData.additional_headers, {key: "", value: ""}],
    }));
  };

  const removeHeaderField = (index) => {
    setFormData((prevData) => ({
      ...prevData,
      additional_headers: prevData.additional_headers.filter((_, i) => i !== index),
    }));
  };

  const handleSubmit = () => {
    if (isEmpty(name) || isEmpty(url) || isEmpty(http_method)) {
      toast.error("Please check required fields");
      return;
    }

    const {additional_headers, ...rest} = formData;

    const headersObject = Object.fromEntries(
      additional_headers
        .filter(({key}) => key.trim())
        .map(({key, value}) => [key.trim(), value.trim()])
    );

    dispatch(
      createUpdateWebHook(
        {
          ...rest,
          additional_headers: headersObject,
          custom_fields: generateCustomFieldsPayload(custom_fields),
        },
        callback
      )
    );
  };

  return {
    formData,
    handleChange,
    handleHeaderChange,
    addHeaderField,
    removeHeaderField,
    handleSubmit,
  };
};
